import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Health and Pods across every workspace (C-16 B-1, GLE-8406). Admins only.
 * The page ships dark behind `manage/me.features.all_workspaces_health`, so
 * the entry waits for it. Its window is set at switch-on: the switch-on ET
 * day to +14 days. Until then both dates are empty, which no window matches,
 * so the entry stays hidden even if the feature turns on first. Each Admin
 * sees it on two ET days (the default, C16-D425).
 */
export const ALL_WORKSPACES_HEALTH: WhatsNewEntryI = {
  id: "all-workspaces-health",
  feature: "all_workspaces_health",
  // Set at switch-on (coordinator): switch-on ET day → +14 days.
  startsAt: "",
  endsAt: "",
  title: {
    [ADMIN]: "Health and Pods for every workspace at once",
  },
  intro: {
    [ADMIN]:
      "Pick All workspaces on Team → Health and Admin → Pods to see every workspace side by side.",
  },
  sections: [
    {
      id: "health",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.TEAM,
      title: "Team → Health",
      items: [
        "Rep health and Campaign health open on All workspaces, with each row's workspace shown by its colour.",
        "A caller on two workspaces has a row on each, with that workspace's numbers.",
        "To change a commitment, a score or a campaign's goal, open that workspace.",
      ],
      link: {
        label: "Open Health",
        href: Router.manageHealth("rep-health"),
      },
    },
    {
      id: "pods",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Admin → Pods",
      items: ["Every workspace's pods in one list, grouped by workspace."],
      link: { label: "Open Pods", href: Router.manageAdmin("pods") },
    },
  ],
};
